import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from "@/libs/api.request";
import { pests } from "./api_url";
/**
 * 删除人员
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintain_del = function maintain_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑人员
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintain_update = function maintain_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取人员列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintain_list = function maintain_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增人员
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintain_add = function maintain_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增人员
 * @param data
 * @returns {*|{responseURL}}
 */

export var project_del = function project_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑项目
 * @param data
 * @returns {*|{responseURL}}
 */

export var project_update = function project_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 项目列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var project_list = function project_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增项目
 * @param data
 * @returns {*|{responseURL}}
 */

export var project_add = function project_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除防制分类
 * @param data
 * @returns {*|{responseURL}}
 */

export var prevent_cate_del = function prevent_cate_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cate_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 防制分类列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var prevent_cate_list = function prevent_cate_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cate_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增防制分类
 * @param data
 * @returns {*|{responseURL}}
 */

export var prevent_cat_add = function prevent_cat_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cat_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑防制分类
 * @param data
 * @returns {*|{responseURL}}
 */

export var prevent_cat_update = function prevent_cat_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cat_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除楼层
 * @param data
 * @returns {*|{responseURL}}
 */

export var floor_del = function floor_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑楼层
 * @param data
 * @returns {*|{responseURL}}
 */

export var floor_update = function floor_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 楼层列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var floor_list = function floor_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增楼层
 * @param data
 * @returns {*|{responseURL}}
 */

export var floor_add = function floor_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除建筑物
 * @param data
 * @returns {*|{responseURL}}
 */

export var building_del = function building_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑建筑物
 * @param data
 * @returns {*|{responseURL}}
 */

export var building_add = function building_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 建筑物列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var building_list = function building_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑建筑物
 * @param data
 * @returns {*|{responseURL}}
 */

export var building_update = function building_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取告警相关下拉
 * @param data
 * @returns {*|{responseURL}}
 */

export var alarm_about = function alarm_about(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_about,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除告警
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_del = function device_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑设备
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_update = function device_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_list = function device_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增设备
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_add = function device_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取设备分类和用途
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_about = function device_about(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_about,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 审核维保记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintenance_audit = function maintenance_audit(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_audit,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 维保管理列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintenance_list = function maintenance_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除告警
 * @param data
 * @returns {*|{responseURL}}
 */

export var alarm_del = function alarm_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 处理告警
 * @param data
 * @returns {*|{responseURL}}
 */

export var handle_alarm = function handle_alarm(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.handle_alarm,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取告警列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var alarm_list = function alarm_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 查看维保报告
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintenance_report = function maintenance_report(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_report,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 下载维保报告
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintenance_download = function maintenance_download(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_download,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 事件记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_event_history = function device_event_history(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_event_history,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 中边中部报警统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_alarm_info = function get_alarm_info(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_alarm_info,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 左上角设备统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_device_info = function get_device_info(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_device_info,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取左下角近一年新增设备
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_year_increase = function device_year_increase(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_year_increase,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 右侧底部项目列表（中部经纬度）统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var indexProject_list = function indexProject_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.indexProject_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取下载token
 * @param data
 * @returns {*|{responseURL}}
 */

export var getdownloadtoken = function getdownloadtoken(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.getdownloadtoken,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 当前用户修改密码
 * @param data
 * @returns {*|{responseURL}}
 */

export var updatepwd = function updatepwd(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.updatepwd,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_onoffline_history = function device_onoffline_history(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_onoffline_history,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var maintenance_download_zip = function maintenance_download_zip(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_download_zip,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var building_trend = function building_trend(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_trend,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取固件信息
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_firmware_info = function get_firmware_info(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_firmware_info,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 升级固件
 * @param data
 * @returns {*|{responseURL}}
 */

export var upup_firmware = function upup_firmware(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.upup_firmware,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导入设备
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_file_import = function device_file_import(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_import,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 查看失败的行
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_file_fail_list = function device_file_fail_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_fail_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导入的文件列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_file_list = function device_file_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * wifi设置
 * @param data
 * @returns {*|{responseURL}}
 */

export var set_device_wifi = function set_device_wifi(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.set_device_wifi,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取控制设置内容
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_device_cmd_config = function get_device_cmd_config(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_device_cmd_config,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 控制设置
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_cmd_config = function device_cmd_config(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_cmd_config,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 蝇害密度分析
 * @param data
 * @returns {*|{responseURL}}
 */

export var midu_analysis = function midu_analysis(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.midu_analysis,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 实时查看
 * @param data
 * @returns {*|{responseURL}}
 */

export var real_time_view = function real_time_view(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.real_time_view,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * ajax拉取图片到web服务器接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var refresh_device_pic_ajax = function refresh_device_pic_ajax(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.refresh_device_pic_ajax,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 项目管理 获取公司列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var company_list = function company_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.company_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};